const mySwiper = new Swiper('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    speed: 400,
    loop: true,
    autoplay: {
          delay: 5000
        },
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  
  // let slider_swipper_container = document.getElementById('slider-swiper-main-container');
  
  // window.addEventListener('DOMContentLoaded', () => {
  //   if(slider_swipper_container){
  //     console.log('Slider Swipper Loader2a');
  //     document.getElementById('slider-swiper-preloader').className = 'success-loaded ';
  //     document.getElementById('slider-swiper-main-container').style.opacity = '1';
  //   }  
  // });
  